import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Props as SelectDropdownProps,
  SelectDropdown,
} from '../../Select/SelectDropdown';
import InputError from '../../form/InputError';
import { getError } from '../utils';

type Props = Omit<SelectDropdownProps, 'value' | 'onChange'> & {
  name: string;
  onValueChange?: (val: string | null) => void;
};

export const SelectDropdownControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name, onValueChange, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getError(name, errors);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <SelectDropdown
            {...props}
            name={field.name}
            onBlur={field.onBlur}
            className={[props.className, error ? 'is-invalid' : null]
              .filter(Boolean)
              .join(' ')}
            value={field.value ?? null}
            onChange={(value) => {
              field.onChange(value);
              onValueChange?.(value);
            }}
            error={error !== undefined}
          />
        )}
      />
      <InputError error={error} />
    </>
  );
};
